import ReactLoading from 'react-loading';
import styled from 'styled-components';

const IconLoader = styled(ReactLoading).attrs({
  color: 'var(--loader-color)',
  type: 'spin',
})`
  width: 1px;
`;

export default IconLoader;
